import { BlackListObject, StaffMember } from "../../types/staff.types";
import { Icon } from "../dashboardComponents/dashboard.styles";
import { SiAdblock } from "react-icons/si";

import {
  StaffCardContainer,
  MemberStatusContainer,
  MemberStatus,
  StatusIcon,
  MemberNameContainer,
  MemberName,
  MemberRole,
  MemberDetails,
  EditButton,
  QrCodeIcon,
  MemberPhone,
} from "./staffCard.styles";
import QrcodeIcon from "../../assets/icons/qrcode.svg";
import { DeleteButton } from "../../routes/dashboard/devices/devices.styles";
import DeleteIcon from "../../assets/icons/delete.svg";
import { ButtonsContainer } from "../modals/addClientModal/addClientModal.styles";
import EditIcon from "../../assets/icons/edit.svg";
import AttendedIcon from "../../assets/icons/attended.svg";
import AbsentIcon from "../../assets/icons/absent.svg";
import { useTranslation } from "react-i18next";
import useBanStaff from "../../hooks/useBanStaff";
import ConfirmationModal from "../modals/confirmationModal/confirmationModal.component";
import { useContext, useRef, useState } from "react";
import Image from "../Image/Image.component";
import { Link } from "react-router-dom";
import { CiLocationOn } from "react-icons/ci";
import { UserContext } from "../../contexts/user.context";
import lateImg from "../../assets/images/late-img.png";
import { MdCalendarMonth } from "react-icons/md";

type StaffCardProps = {
  member: StaffMember;
  deleteMember?: ((qrcode: string) => void) | null;
  startEditingMember?: ((member: StaffMember) => void) | null;
  showQrCode?: ((member: StaffMember) => void) | null;
  timeIn?: string;
  timeOut?: string;
  duration?: string;
  showStatus?: boolean;
  showBlackButton?: boolean;
  blackListedAttendee?: BlackListObject;
  isBlocked?: boolean;
  isAttendee?: boolean;
  getAllStaff?: () => Promise<void>;
  location?: string;
  locationOut?: string;
  setOpenStaffAttendanceCount?: React.Dispatch<React.SetStateAction<boolean>>;
  setStaffData?: React.Dispatch<React.SetStateAction<any>>;
};
const StaffCard = ({
  member,
  deleteMember,
  startEditingMember,
  showQrCode,
  timeIn,
  timeOut,
  duration,
  showStatus,
  showBlackButton,
  blackListedAttendee,
  isBlocked,
  isAttendee,
  getAllStaff,
  location,
  locationOut,
  setOpenStaffAttendanceCount,
  setStaffData,
}: StaffCardProps) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const staffId = useRef(0);
  const { t } = useTranslation();
  const { unbanStaff, isLoading } = useBanStaff();
  const { permissions } = useContext(UserContext);

  const displayStaff = () => {
    return (
      <StaffCardContainer className="border rounded-md">
        {blackListedAttendee?.isBlacklisted ? (
          <article className="blacklist">
            <div className="flex items-center gap-3">
              <span className="bg-black text-white text-2xl font-bold rounded-full w-12 h-12 flex items-center justify-center mb-2">
                <SiAdblock />
              </span>
              <p className="font-bold mb-2 text-xl">Blocked</p>
            </div>
            <div className="tooltip-container !z-[99999]">
              <div className="tooltip !w-fit">
                <div className="profile">
                  <div className="user">
                    <div className="img">
                      <Image
                        src={blackListedAttendee.staff_img}
                        alt="Staff Image"
                      />
                    </div>
                    <div className="details">
                      <h3 className="name !text-red-500">Blocked</h3>
                      <h3 className="username">
                        @{blackListedAttendee.staff_name}
                      </h3>
                    </div>
                  </div>
                  <h4 className="about">
                    Duration: {blackListedAttendee?.block_duration}{" "}
                    {+blackListedAttendee?.block_duration > 1 ? "Days" : "Day"}
                  </h4>
                </div>
              </div>
            </div>
          </article>
        ) : (
          !deleteMember &&
          !startEditingMember &&
          !showQrCode &&
          showStatus && (
            <MemberStatusContainer>
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-2">
                  <StatusIcon
                    style={{ width: 38, height: 38 }}
                    src={member.attendance == 1 ? AttendedIcon : AbsentIcon}
                    draggable={false}
                  />
                  <MemberStatus>
                    {member.attendance == 1 ? t("attended") : t("absent")}
                  </MemberStatus>
                </div>
                <div
                  className="flex items-center gap-3"
                  onClick={() => {
                    setOpenStaffAttendanceCount?.(true);
                    setStaffData?.({
                      staff_id: member.asdc_client_staff_id,
                      staff_departments_WorkShift_relationShip:
                        member?.staff_departments_WorkShift_relationShip,
                    });
                  }}
                >
                  <button>
                    <MdCalendarMonth size={22} />
                  </button>
                  {member?.staff_attendance?.late && (
                    <div>
                      <img
                        src={lateImg}
                        alt="lateImg"
                        loading="lazy"
                        className="w-[40px] "
                      />
                    </div>
                  )}
                </div>
              </div>
            </MemberStatusContainer>
          )
        )}
        <div className="w-56">
          <Image
            className="!w-full aspect-square mb-4 object-cover"
            src={member?.asdc_client_profile_pic_url}
            alt="Staff Profile Pic"
          />
        </div>
        <MemberDetails>
          <MemberNameContainer>
            {!blackListedAttendee?.isBlacklisted && (
              <MemberName>{member?.asdc_client_staff_name}</MemberName>
            )}
            {showQrCode && (
              <QrCodeIcon
                src={QrcodeIcon}
                title="qrcode"
                onClick={() => showQrCode(member)}
              />
            )}
          </MemberNameContainer>
          <MemberRole>{member?.asdc_client_staff_title}</MemberRole>

          {blackListedAttendee?.isBlacklisted ? (
            <h4>Reason: {blackListedAttendee?.block_reason}</h4>
          ) : (
            <>
              {timeIn && <p>Time In: {timeIn}</p>}
              {timeOut && <p>Time Out: {timeOut}</p>}
              {duration && <p>Duration: {duration}</p>}
            </>
          )}
          {isBlocked && <h4>Reason: {blackListedAttendee?.block_reason}</h4>}
          {isBlocked && (
            <h4>
              Duration:{" "}
              {Math.ceil(
                (+new Date(blackListedAttendee?.block_endDate || "") -
                  +new Date()) /
                  (1000 * 60 * 60 * 24)
              )}{" "}
              Days
            </h4>
          )}
          {location && (
            <a
              className="text-blue-500"
              href={location}
              target="_blank"
              rel="noreferrer"
            >
              {locationOut ? "location In" : "location"}{" "}
              <CiLocationOn className="inline-block text-2xl" />
            </a>
          )}
          {locationOut && (
            <a
              className="text-blue-500"
              href={locationOut}
              target="_blank"
              rel="noreferrer"
            >
              location Out <CiLocationOn className="inline-block text-2xl" />
            </a>
          )}
          <MemberPhone title="Call">
            <button>
              <Link to={`tel:${member?.asdc_client_staff_phone}`}>
                {member?.asdc_client_staff_phone}
              </Link>
            </button>
          </MemberPhone>
          {deleteMember && startEditingMember && (
            <ButtonsContainer
              style={{
                justifyContent: "space-between",
                gap: 0,
                marginTop: 0,
              }}
            >
              <EditButton
                onClick={() =>
                  startEditingMember({
                    asdc_client_staff_name: member.asdc_client_staff_name,
                    asdc_client_staff_title: member.asdc_client_staff_title,
                    asdc_client_staff_phone: member.asdc_client_staff_phone,
                    asdc_client_staff_qrcode: member.asdc_client_staff_qrcode,
                  } as StaffMember)
                }
              >
                <Icon
                  src={EditIcon}
                  style={{ width: "16px", height: "16px" }}
                />
                {t("edit")}
              </EditButton>
              <DeleteButton
                style={{ width: "47%", gap: "0.5rem" }}
                onClick={() => deleteMember(member.asdc_client_staff_qrcode)}
              >
                <Icon
                  src={DeleteIcon}
                  style={{ width: "16px", height: "16px" }}
                />
                {t("deleteBtn")}
              </DeleteButton>
            </ButtonsContainer>
          )}
        </MemberDetails>
        {showBlackButton &&
          (permissions?.Staffs?.update || permissions?.Staffs?.delete) && (
            <button
              onClick={() => {
                setIsConfirmationModalOpen(true);
                staffId.current = Number(member.BlackList[0].id);
              }}
              className="bg-red-500 text-white rounded-lg p-3 mt-5 block mx-auto w-full"
            >
              {t("remove_black_list")}
            </button>
          )}
        <ConfirmationModal
          title={t("remove_black_list")}
          message={t("confirm_delete")}
          isLoading={isLoading}
          onConfirm={() =>
            unbanStaff(
              staffId.current,
              () => {
                if (getAllStaff) getAllStaff();
              },
              () => setIsConfirmationModalOpen(false),
              true
            )
          }
          closeConfirmationModal={() => setIsConfirmationModalOpen(false)}
          isShown={isConfirmationModalOpen}
          strict={true}
        />
      </StaffCardContainer>
    );
  };

  const filterStaff = () => {
    if (isBlocked) return displayStaff();
    else if (isAttendee) return displayStaff();
  };

  return filterStaff();
};
export default StaffCard;
